import Modal from '../../../../../component/modal/Modal';
import alertIcon from '../../../../../assets/image/alert-icon.svg';
import Button from '../../../../../component/ui/Button';

const ExcessPaymentModal = ({
	isModalOpen,
	setIsModelOpen,
	handlePaymentReceived,
	handleLater,
	handleCreditNote,
	excessAmount,
}) => {
	return (
		<Modal
			isOpen={isModalOpen}
			title={`Excess Payment`}
			className="deleteVendorsModal"
			onClose={() => {
				setIsModelOpen(false);
			}}
			cancelButton={() => {
				setIsModelOpen(false);
			}}
		>
			<div>
				<div style={{ display: 'flex', padding: '20px 0px' }}>
					<img
						src={alertIcon}
						alt="Alert"
					/>
					<div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', color: '#00000' }}>
						{`Would you like to store the excess amount of ₹ ${excessAmount} as advance payment from this customer?`}
					</div>
				</div>
				<p style={{ fontSize: '14px', fontWeight: '400', color: '#00000' }}>
					Note: the excess amount will be converted into a credit note.
				</p>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					marginTop: '10px',
					justifyContent: 'center',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-primary add-pro"
					button="Create Credit Note"
					disabled={false}
					onClick={handleCreditNote}
				/>

				<Button
					type="button"
					button="Excess Paid to Customer"
					className="mt-0 px-4 btn-primary relative"
					onClick={handlePaymentReceived}
				/>
				<Button
					type="button"
					button="Later"
					className="mt-0 px-4 btn-primary relative"
					onClick={handleLater}
				/>
			</div>
		</Modal>
	);
};

export default ExcessPaymentModal;
